// Persistent review notes for consultation billing: missing prices, stock issues, non-billable and already-billed entries.
const Row = ({ title, items, tone, testid, label }) => (
  items.length ? (
    <div className={`rounded-md px-2.5 py-1.5 ${tone}`} data-testid={testid}>
      <div className="font-semibold">{title}</div>
      <div>{items.map(label).join(", ")}</div>
    </div>
  ) : null
);

const stockLabel = (x) => `${x.name} ×${x.qty - x.billed_qty}${x.missing_product ? " (product not found — not added)" : x.insufficient_stock ? ` (only ${x.stock} in stock)` : ""}${!x.missing_product && !(Number(x.price) > 0) ? " (no selling price)" : ""}`;

export function EncounterNotice({ note, onRefresh }) {
  if (!note) return null;
  const stock = note.stock || [];
  const any = note.missing.length || note.notBillable.length || note.billed.length || stock.length || (note.rx || []).length;
  if (!any && !onRefresh) return null;
  return (
    <div className="mb-3 space-y-1.5 text-xs" data-testid="pos-encounter-notice">
      {onRefresh && (
        <div className="flex items-center justify-between gap-2 rounded-md bg-violet-50 px-2.5 py-1.5 text-violet-800">
          <span>Items from the vet consultation are loaded automatically.</span>
          <button type="button" onClick={onRefresh} className="font-semibold underline" data-testid="pos-enc-refresh">Refresh from consultation</button>
        </div>
      )}
      <Row title="No catalogue price — not added (ask the vet to link a priced service, or add manually)" items={note.missing}
        tone="bg-amber-50 text-amber-800" testid="pos-enc-missing-price" label={(x) => x.clinical_name} />
      <Row title="Dispensed medicines needing attention" items={stock}
        tone="bg-rose-50 text-rose-800" testid="pos-enc-stock-issues" label={stockLabel} />
      <Row title="Not billable (planned / not administered)" items={note.notBillable}
        tone="bg-slate-50 text-slate-600" testid="pos-enc-not-billable" label={(x) => `${x.name} (${x.kind})`} />
      <Row title="Prescribed only — not dispensed, not charged" items={note.rx || []}
        tone="bg-slate-50 text-slate-600" testid="pos-enc-prescribed-only" label={(x) => `${x.medication_name}${x.dosage ? ` · ${x.dosage}` : ""}${x.frequency ? ` · ${x.frequency}` : ""}`} />
      <Row title="Already billed" items={note.billed}
        tone="bg-emerald-50 text-emerald-800" testid="pos-enc-already-billed" label={(x) => x.name} />
    </div>
  );
}
